export default {
  settings: 'Nustatymai',
  settingsSubtitle: 'Lunch App sistemos nustatymai.',
  preferredLanguage: 'Pageidautina kalba',
  city: 'Miestas',
  appearance: 'Išvaizda',
  appearanceSubtitle: 'Vartotojo sąsajos spalvų keitimas pagal pageidavimus.',
  displayName: 'Vardas ir Pavardė',
  primary: 'Pagrindinė',
  secondary: 'Antrinė',
  info: 'Informacija',
  error: 'Klaida',
  manageUsers: 'Redaguoti vartotojų duomenis',
  searchByName: 'Paieška pagal vartotojo vardą',
  userEditing: 'Vartotojų Redagavimas',
  displayname: 'Vardas ir Pavardė',
  admin: 'Administratorius',
  active: 'Aktyvus',
  inactive: 'Neaktyvus',
  updatedUser: 'Sėkmingai atnaujinti vartotojo duomenys.',
  disableFancyOrderNotifications: 'Išjungti "fancy" užsakymo pranešimus.',
  dailyStartHour: 'Numatytoji valanda dienos pietums',
  dailyStartDay: 'Numatytoji diena dienos pietums',
  fridayStartHour: 'Numatytoji valanda penktadienio pietums',
  fridayStartDay: 'Numatytoji diena penktadienio pietums',
  ordersWithoutDepositDate: 'Užsakymas be depozito datai',
  ordersWithoutDeposit: 'Užsakymas be depozito',
  ordersWithoutDepositUndoText:
    'Vartotojas {displayName} gali visada užsisakinėti be depozito. Ar norite tai anuliuoti ir leisti užsisakyti be depozito tik pasirinktai datai?',
};
